import { useEffect, useMemo, useRef } from "react";

export default function FileField({
  id,
  name,
  label,
  value,
  className,
  onChange,
  onUpload,
  algoritmo,
  disabled,
  accept,
  fileName,
  isInvalid,
  style,
  labelStyle,
  error,
  ...props
}) {
  const inputRef = useRef();
  const handleChange = useMemo(
    () => (event) => {
      if (event.target === inputRef.current) {
        if (onChange instanceof Function) {
          onChange(event);
        }
      } else {
        event.stopPropagation();
      }
    },
    [onChange],
  );
  const handleArchivoChange = (event) => {
    inputRef.current.value = event.target.value;
    inputRef.current.file = event.target.files?.[0];
    inputRef.current.name = name;
    inputRef.current.dispatchEvent(
      new Event("change", { cancelable: true, bubbles: true, composed: false }),
    );
  };
  useEffect(() => {
    const input = inputRef.current;
    const onChange = handleChange;
    if (!!input) {
      input.addEventListener("change", onChange);
      return () => {
        input.removeEventListener("change", onChange);
      };
    }
  }, [handleChange]);
  const computedClassName = [
    "form-group",
    "file-field",
    isInvalid ? "has-error" : "",
    ...((!!className && className.split(" ")) || []),
  ]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} style={style} {...props} ref={inputRef}>
      <label for={`${id}_file`} style={labelStyle} className="control-label">
        {label}
      </label>
      <input
        id={`${id}_file`}
        type="file"
        value={value}
        onInput={handleArchivoChange}
        style={labelStyle}
        disabled={disabled}
        accept={accept}
      />
      {isInvalid && !!error && <span className="help-block">{error}</span>}
    </div>
  );
}
